export default function loggingMiddleware({ dispatch, getState }) {
  return function(next) {
    return function(action) {
      console.log('loggingMiddleware action received:', action)
      return next(action)
    }
  }
}
